import React from 'react';

/**
 * ProviderBadge — a small pill identifying a mailbox's provider (Gmail /
 * Outlook), so the user can tell at a glance which provider a mailbox uses
 * without reading the email address.
 *
 * Colour matches the provider branding used elsewhere in the app (red for
 * Gmail, blue for Outlook) — part of MailboxSwitcher's "Design A, locked
 * 2026-07-27" convention, which is why this is an extraction rather than a
 * fresh component: MailboxSwitcher imports it from here instead of keeping a
 * private copy, so there is one pill, not two.
 *
 * Not to be confused with `ProviderConnectionBadges`, which renders CONNECTION
 * STATUS (connected / needs-reconnect / disconnected). This one renders
 * provider IDENTITY only.
 */
export default function ProviderBadge({ provider }) {
    if (!provider) return null;
    const isGmail = provider === 'gmail';
    return (
        <span
            className={`text-[10px] px-1 py-0.5 rounded font-medium ${
                isGmail
                    ? 'bg-red-50 text-red-600'
                    : 'bg-blue-50 text-blue-600'
            }`}
            data-testid={`provider-badge-${provider}`}
        >
            {isGmail ? 'Gmail' : 'Outlook'}
        </span>
    );
}
